import React, { useCallback, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import { Select } from '@doxyme/ui';
import COUNTRIES from '../../../../common/services/country/countries.json';
import './country-select.scss';
export function CountrySelect({ countryCode, handleChange, disabled = false }) {
    const { formatMessage } = useIntl();
    const selectOptions = useMemo(() => {
        return [
            ...Object.keys(COUNTRIES).map((code) => ({
                label: (<span>
              <div className={`country-img iti-flag ${code.toLowerCase()}`}/>
                <FormattedMessage id={`common.country.${code}`} defaultMessage={COUNTRIES[code]}/>
            </span>),
                value: code,
            })),
        ];
    }, [COUNTRIES]);
    const [options, setOptions] = useState(selectOptions);
    const onChange = useCallback((e) => {
        handleChange(e);
        setOptions(selectOptions);
    }, [handleChange]);
    const handleSearch = useCallback((e) => {
        let searchedValue = e.target.value;
        let newOptions = selectOptions.filter((val) => {
            return formatMessage({ id: `common.country.${val.value}` }).toLowerCase().includes(searchedValue.toLowerCase());
        });
        setOptions(newOptions);
    }, [selectOptions]);
    const { control, } = useForm({
        mode: 'onChange',
        defaultValues: {
            countryCode: countryCode ? countryCode : null,
        },
    });
    return (<Select data-test-id="country-select" formGroupClassName="country-select" name="countryCode" label={formatMessage({
            id: 'common.billing-country',
        })} placeholder={formatMessage({
            id: 'common.choose-billing-country',
            defaultMessage: 'Choose Billing country'
        })} disabled={disabled} control={control} options={options} hasSearchBar={true} searchPlaceholder={formatMessage({
            id: 'common.search',
            defaultMessage: 'Search'
        })} handleSearch={handleSearch} onChange={onChange}/>);
}
